import { render } from "./MyData.vue?vue&type=template&id=3e8fad76&scoped=true"
import script from "./MyData.vue?vue&type=script&lang=js"
export * from "./MyData.vue?vue&type=script&lang=js"

import "./MyData.vue?vue&type=style&index=0&id=3e8fad76&scoped=true&lang=css"

import exportComponent from "D:\\phpstudy_pro\\data.yuandiansiyu.com\\platform_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e8fad76"]])

export default __exports__